import styled, { keyframes } from 'styled-components';

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.loading.wrapperBg};
  z-index: 100;

  &.white {
    background-color: ${(props) => props.theme.loading.bg};
  }

  &.extend {
    top: -5px;
    bottom: -5px;
    height: 125%;
  }
`;

export const ldsEllipsis = styled.div`
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;

  .MuiCircularProgress-root {
    color: ${(props) => props.theme.loading.lds};
  }

  &.small {
    width: 20px;
    height: 20px;

    .MuiCircularProgress-root {
      width: 20px !important;
      height: 20px !important;
    }
  }
`;
